export const APPROX_STATUSBAR_HEIGHT = 0;
